var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#B2C8D8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6ZM15 11H15.5279C16.1156 11.0003 16.6976 11.1154 17.2404 11.3388C17.7833 11.5623 18.2764 11.8896 18.6917 12.3021C19.107 12.7147 19.4363 13.2044 19.6608 13.7432C19.8853 14.282 20.0005 14.8594 20 15.4424V22H16V17.5C16 17.5 16 17 15.5 17C15 17 15 17.5 15 17.5V22H9V17.5C9 17.5 9 17 8.5 17C8 17 8 17.5 8 17.5V22H4V15.4383C4 14.8554 4.11576 14.2782 4.34067 13.7396C4.56559 13.2011 4.89525 12.7117 5.31082 12.2996C5.7264 11.8874 6.21976 11.5605 6.76271 11.3376C7.30567 11.1146 7.88758 10.9999 8.47522 11H9L12 13L15 11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateIcon);
export default __webpack_public_path__ + "static/media/candidate-icon.781c710a.svg";
export { ForwardRef as ReactComponent };